module.exports = __webpack_public_path__ + "img/drinks-1.65780c7f.jpg";